import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LegalSection } from 'admin-common';
import { translatedList } from 'src/app/shared/utils/translated-content';

@Component({
    selector: 'app-legal-notice',
    templateUrl: './legal-notice.component.html',
    styleUrls: ['./legal-notice.component.scss'],
    standalone: false
})
export class LegalNoticeComponent {
  bigTitle: string = 'homePage.legalNotice.bigTitle';
  bank = 'WUnivers';
  website: string = 'https://www.wissalunivers.com';

  /** Sections in the current language; `{website}` is filled by lib-legal-information. */
  legalInfo: LegalSection[];

  constructor(translate: TranslateService) {
    this.legalInfo = translatedList<LegalSection>(translate, 'homePage.legalNotice.sections');
  }
}
